// extracted by mini-css-extract-plugin
export default {"toggle":"toggle_toggle__ySr0l","toggled":"toggle_toggled__iYPqU","toggleCircle":"toggle_toggleCircle__toRU3"};